import { AbstractControl, FormArray, FormControl, FormGroup } from "@angular/forms";

// Controlar validators
export function formTouched(form: AbstractControl<any, any[]>) {
    form.markAllAsTouched();

    if (form instanceof FormGroup) {
        for (const key in form.controls) {
            if (form.controls.hasOwnProperty(key)) {
                form.get(key)?.markAsDirty();
            }
        }
    }
}


export function markArrayDirty(formArray: FormArray) {
    formArray.controls.forEach((control: any) => {
        if(!!control.controls) {
            if(Array.isArray(control.controls)) {
                control.markAsDirty();
                markArrayDirty(control as FormArray);
            } else {
                markGroupDirty(control as FormGroup);
            }
        } else {
            markControlDirty(control as FormControl);
        }
    });
}

export function markControlDirty(formControl: FormControl) {
    formControl.markAsDirty();
}

export function markAbstractControlTouched(abstractControl: AbstractControl<any, any> | null) {
    abstractControl?.markAsTouched();
}

export function markAbstractControlDirty(abstractControl: AbstractControl<any, any> | null) {
    abstractControl?.markAsDirty();
}

export function markDirty(form: FormGroup) {
    markGroupDirty(form);
}

export function markGroupDirty(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
        const control: any = formGroup.get(key);

        if(!!control.controls) {
            if(Array.isArray(control.controls)) {
                formGroup.get(key)?.markAsDirty();
                markArrayDirty(formGroup.get(key) as FormArray);
            } else {
                markGroupDirty(formGroup.get(key) as FormGroup);
            }
        } else {
            markControlDirty(formGroup.get(key) as FormControl);
        }
    });
}


export function cleanForm(form: any): void {
    for (let key in form.value) {
        if (form.get(key)?.value != '' && form.get(key)?.value != null && typeof (form.get(key)?.value) == 'string') {
            form.get(key)?.setValue(form.get(key)?.value.trim());
        }
    }
}
